
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/team/[id]/[slug]/print",
      function () {
        return require("private-next-pages/shop/team/[id]/[slug]/print.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/team/[id]/[slug]/print"])
      });
    }
  